import React from 'react'

function Loading() {
  return (
    <div className="flex justify-center py-8">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600"></div>
  </div>
  )
}

export default Loading
